<template>
  <div>
    <v-row :align="is_field_error ? 'baseline' : 'center'">
      <v-col
        :align="isMobile ? 'left' : 'right'"
        cols="12"
        xs="12"
        sm="12"
        md="3"
        lg="2"
        xl="2"
      >
        <p style="font-weight: bold; margin-bottom: 0!important; font-size: 15px;">
          <span
            v-if="is_required"
            style="color: red;"
          >*</span> {{title}}:
        </p>
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="7"
        lg="6"
        xl="6"
      >
        <v-combobox
          outlined
          single-line
          dense
          hide-details='auto'
          :value="value"
          :items="items"
          @input="update_value"
          @update:error="error_value"
          :rules="rules"
          :placeholder="placeholder"
          :multiple="multiple"
        ></v-combobox>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    is_required: Boolean,
    value: Array,
    rules: Array,
    placeholder: String,
    items: Array,
    multiple: Boolean
  },
  data: function () {
    return {
      is_field_error: false,
    };
  },
  methods: {
    update_value(value) {
      this.$emit('input', value);
    },
    error_value(is_error) {
      if (is_error) {
        this.is_field_error = true;
      } else {
        this.is_field_error = false;
      }
    }
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return true;
        case "lg":
          return false;
        case "xl":
          return false;
        default:
          return false;
      }
    },
  },
}
</script>

<style>
</style>